import styled from '@emotion/styled';

import { media } from '../../utils/styled';

const Grid = styled.ol`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: auto;
  gap: ${(p) => p.theme.spacing.xlarge};

  ${(p) => media.md`
    > * {
      margin: ${p.theme.spacing.default};
    }
  `}

  ${media.sm`
    grid-template-columns: 1fr;
  `}
`;

export default Grid;
